import { PatientFileVersion } from "../../../amplify/appsync/query";
import { PatientVisit } from "../../../amplify/appsync/search-patients";
import { getRelativeDate, parseAsPacific } from "../../../utils/time";

export function chunkArray(arr: any, size: number = 3) {
    const chunks: any = [];
    for (let i = 0; i < arr.length; i += size) {
        chunks.push(arr.slice(i, i + size));
    }
    return chunks;
}

export const getChunkKey = (chunks: any[]) => {
    let chunkKey = "";
    for (let study of chunks) {
        chunkKey += `${study.study}${study.result_time}`;
    }
    return chunkKey;
};

export const truncateString = (str: string, maxLength = 500) => {
  return str.length > maxLength ? str.slice(0, maxLength) : str;
}

export const isSectionUnread = (key: string, unreadFileVersionMap?: Record<string, PatientFileVersion>) => {
    return unreadFileVersionMap ? unreadFileVersionMap[key] : false;
}

export const processTextForCopy = (str: string, anchorDate: Date) => {
    let text = str;

    // Preprocess timestamps: (YYYY-MM-DD, YYYY-MM-DD HH:MM, YYYY-MM-DD HH:MM:SS PT)
    // Regex to match timestamps with optional parentheses
    const timestampRegex = /(\()?((?:\d{4}-\d{2}-\d{2}(?: \d{2}:\d{2}(?::\d{2})?)?(?: PT)?)(?:,\s*\d{4}-\d{2}-\d{2}(?: \d{2}:\d{2}(?::\d{2})?)?(?: PT)?)*)(\))?/g;

    text = text.replace(timestampRegex, (_, openParen, timestamps, closeParen) => {
        const parts = timestamps.split(/\s*,\s*/).filter(Boolean).map((ts: string) => {
            const cleanTs = ts.replace(" PT", "");
            const dateObj = parseAsPacific(cleanTs);
            const relative = getRelativeDate(dateObj, anchorDate);
            return `(${relative})`; // wrap each timestamp in parentheses
        });

        const joined = parts.join(", ");

        // Only remove parentheses if BOTH exist and fully surround the timestamps
        if (openParen && closeParen) {
            return `${joined}`;
        }

        return `${openParen || ""}${joined}${closeParen || ""}`;
    });

    // Remove citations in square brackets
    text = text.replace(/\[\s*\d+(?:\s*[,--]\s*\d+)*\s*\]/g, '');

    // Remove multiple consecutive commas (including ones left after citations)
    text = text.replace(/,+/g, ',')       // collapse multiple commas
            .replace(/,\s*,/g, ',')   // remove comma followed by comma
            .replace(/\s*,\s*\./g, '.') // remove comma before period
            .replace(/^\s*,|,\s*$/g, '') // leading/trailing commas
            .replace(/\s{2,}/g, ' ');   // extra spaces

    // Remove spaces before punctuation (.,!?:;)
    text = text.replace(/\s+([.,!?:;])/g, '$1');

    // Remove extra spaces caused by removal
    text = text.replace(/\s{2,}/g, ' ').trim();

    return text;
};

export const isLobby = (patientVisit: PatientVisit) => {
    const bed = patientVisit.bed;
    if (!bed) {
        return false;
    }
    return bed.startsWith("EDW") || bed.startsWith("Waiting") || bed.startsWith("LDC");
}
